
import PaginationTpl from "components/base/PaginationTpl";
import Financial from "models/financial";
import ImgUploader from 'common/js/img-upload'
const imgUploader = new ImgUploader();
import warehouseMixins from 'common/mixins/warehouse.js'
import projectMixins from 'common/mixins/project.js'
import WarehouseProjectSelect from '@/components/base/select/warehouse-project-select.vue'
import { getDBUserRealName } from "common/js/storage";
import { numsToRMBSymbolAndMillimeter, keepTwoDecimal, downLoadFile, debounce, formaTimeToAllSecond, downLoadFileByBlob } from "common/js/util";
const STATUS = { 1: '待核实', 2: '已核实', 3: '待确认', 4: '已确认' }
const FEE_TYPE = { 1: "仓储费用", 2: "操作费用", 3: "物流费用", 4: "其他费用", 5: "索赔费用" };
export default {
  mixins: [warehouseMixins, projectMixins],
  components: {
    PaginationTpl,
    WarehouseProjectSelect
  },
  data() {
    return {
      id: '',
      projectId: null,
      menuList: [
        { name: '日账单', url: '/operate/finance/customerBill/customerDateBill' },
        { name: '月账单', url: '/operate/finance/customerBill/customerMonthBill' },
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      // 多个账单导出id集合
      billIdList: [],
      // 单个账单导出id集合
      oneBillIdList: [],
      billRecalculationForm: {
        warehouseId: '',
        projectId: '',
        freightRecalculation: 0,
        date: '',
        telephone: ''
      },
      billRecalculationFormRules: {
        warehouseId: [
          { required: true, message: "请选择仓库", trigger: "change" },
        ],
        date: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        telephone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
      },
      // 运费重算列表
      freightRecalculationList: [
        { id: 1, name: '是' },
        { id: 0, name: '否' },
      ],
      billRecalculationDrawer: false,
      drawer: false,
      // 选择的仓库和项目
      parentSelectWarehouseAndProject: [],
      // 上一个项目id
      prevProjectId: null,
      // 下一个项目id
      nextProjectId: null,
      // 上一个账单id
      prevBillId: null,
      // 下一个账单id
      nextBillId: null,
      baseInfoForm: {
        customerName: '',
        projectName: '',
        billTime: '',
        amount: 0,
        // 税率
        taxRate: '',
        // 含税金额
        taxes: 0,
        // 计费规则备注
        projectRemark: ''
      },
      // 上传文件数据
      fileList: [],
      images: [],
      isUploadText: true,
      // 费用明细列表
      list: [],
      // 调整记录列表
      recordsData: [],
      recordsTitleList: [
        { label: "日期", prop: "time", width: "200", alignment: 'left' },
        { label: "操作员", prop: "operator", width: "", alignment: 'left' },
        { label: "科目名称", prop: "accountName", width: "", alignment: 'left' },
        { label: "金额", prop: "amount", width: "", alignment: 'right' },
        { label: "备注", prop: "remarks", width: "", alignment: 'left' },
      ],
      // 1：调整时间（降序）、2：科目id（升序）
      sortType: null,
      recordsTotal: 0,
      recordsCurrentPage: 1,
      recordsPageSize: 20,

      dialog: false,
      billDateDetails: null,
      // 明细id
      billFeeDetailId: null,
      billForm: {
        amount: null,
        remarks: "",
      },

      modifyRemarksDialog: false,
      modifyRemarksForm: {
        id: "",
        remarks: "",
      },

      // 开启月账单导出
      exportDialog: false,
      // 月账单类型
      monthExportRadio: 1,
      // 月账单类型集合
      monthExportTypeList: [
        {id:1, name: '原始账单'},
        {id:2, name: '初账单'},
        {id:3, name: '确认账单'},
        {id:4, name: '汇总账单'},
      ],
      styleList: [
        { id: 1, name: '待核实' },
        { id: 2, name: '已核实' }
      ],
      // 项目明细
      subject: null,

      //设置今天以后不可选
      pickerOptions: {
        //限制时间
        selectableRange: this.selectableRange(),
        // 限制日期
        disabledDate: this.disabledDate,
      },
    };
  },

  created() {
    this.initWarehouse();
    this.initProjectByWarehouse();
    // 上一页防抖
    this.proFnc = debounce(() => {
      this.projectId = this.prevProjectId
      this.id = this.prevBillId
      this.initDetailsInfo()
    }, 800)
    // 下一页防抖
    this.nextFnc = debounce(() => {
      this.projectId = this.nextProjectId
      this.id = this.nextBillId
      this.initDetailsInfo()
    }, 800)
  },

  methods: {
    selectableRange() {
      let date = new Date();
      let hour = date.getHours();
      hour = hour > 9 ? hour : "0" + hour;
      let minute = date.getMinutes();
      minute = minute > 9 ? minute : "0" + minute;
      let second = date.getSeconds();
      second = second > 9 ? second : "0" + second;
      let time = `${hour}:${minute}:${second}`;
      const selectableRange = `${time}-23:59:59`;
      return selectableRange;
    },

    disabledDate(date) {
      //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
      return date.getTime() > Date.now();
    },
    /**
     * @desc 获取账单列表
     */
    initFinancicalReconciliationList() {
      let pageNo = this.currentPage
      let type = this.search.select
      let billDate = ''
      let startDate = ''
      let endDate = ''
      if (type === 1) {
        startDate = this.search.date ? this.search.date[0] : ''
        endDate = this.search.date ? this.search.date[1] : ''
      } else {
        billDate = this.search.month ? this.search.month : ''
      }
      let customerId = this.search.customer
      let projectId = this.search.projectId
      let warehouseId = this.search.warehouseId
      let status = this.search.status
      Financial.getFinancial(type, pageNo, billDate, customerId, warehouseId, projectId, startDate, endDate, status).then(res => {
        if (res.success) {
          this.pageSize = res.result.pageSize;
          this.total = res.result.totalNum;
          let arr = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.customerName;
            obj.creatTime = value.billDate;
            obj.amount = numsToRMBSymbolAndMillimeter(value.totalAmount);
            obj.projectName = value.projectName;
            obj.projectId = value.projectId;
            obj.type = value.type;
            obj.status = value.status;
            obj.statusVal = STATUS[value.status];
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * @desc 获取账单详情数据
     */
    initBillDetails() {
      let billDate = this.billDateDetails
      let projectId = this.projectId
      let data = {
        billDate,
        projectId
      }
      Financial.getDetails(data).then((res) => {
        if (res.success) {
          let arr = [];
          let {
            id,
            attachments,
            customerName,
            projectName,
            projectId,
            status,
            taxRate,
            billDate,
            projectRemark,
            totalAmount,
            totalTaxIncludedAmount,
            feeList,
            // 上一个项目id
            prevProjectId,
            // 下一个项目id
            nextProjectId,
            // 上一个账单id
            prevBillId,
            // 下一个账单id
            nextBillId
          } = res.result;
          if (attachments) {
            if (attachments.length > 0) {
              this.isUploadText = false
            }
            this.fileList = attachments
          } else {
            this.fileList = []
          }
          this.oneBillIdList = [id]
          this.id = id
          this.prevProjectId = prevProjectId
          this.nextProjectId = nextProjectId
          this.prevBillId = prevBillId
          this.nextBillId = nextBillId
          this.baseInfoForm.customerName = customerName;
          this.baseInfoForm.projectName = projectName;
          this.baseInfoForm.projectId = projectId;
          this.baseInfoForm.status = status;
          this.baseInfoForm.statusVal = STATUS[status];
          this.baseInfoForm.taxRate = taxRate;
          this.baseInfoForm.billTime = billDate;
          this.baseInfoForm.projectRemark = projectRemark;
          this.baseInfoForm.amount = numsToRMBSymbolAndMillimeter(totalAmount);
          this.baseInfoForm.taxes = numsToRMBSymbolAndMillimeter(totalTaxIncludedAmount);
          let parentSelectWarehouseAndProject = []
          let projectObj = {}
          projectObj.name = projectName
          projectObj.id = projectId
          parentSelectWarehouseAndProject.push(projectObj)
          this.parentSelectWarehouseAndProject = parentSelectWarehouseAndProject
          this.$bus.emit('initParentSelectWarehouseAndProject', parentSelectWarehouseAndProject)
          feeList.map((value) => {
            let obj = {};
            obj.totalAmount = numsToRMBSymbolAndMillimeter(value.totalAmount);
            obj.totalTaxIncludedAmount = numsToRMBSymbolAndMillimeter(value.totalTaxIncludedAmount);
            obj.feetype = value.feeType;
            obj.feetypeVal = FEE_TYPE[value.feeType];
            obj.tableData = [];
            value.feeDetailList.map((i) => {
              let wareHouse = {};
              wareHouse.id = i.id;
              wareHouse.adjustFlag = i.adjustFlag;
              wareHouse.detailed = i.detailName;
              wareHouse.isRecord = i.checkFlag;
              wareHouse.data = i.value;
              wareHouse.chargeServiceId = i.chargeServiceId;
              wareHouse.amount = i.amount;
              wareHouse.amountCopy = numsToRMBSymbolAndMillimeter(i.amount);
              wareHouse.oldAmount = i.oldAmount;
              wareHouse.oldAmountCopy = numsToRMBSymbolAndMillimeter(i.oldAmount);
              wareHouse.oldTaxIncludedAmount = i.oldTaxIncludedAmount;
              wareHouse.oldTaxIncludedAmountCopy = numsToRMBSymbolAndMillimeter(i.oldTaxIncludedAmount);
              wareHouse.taxes = i.taxIncludedAmount;
              wareHouse.taxesCopy = numsToRMBSymbolAndMillimeter(i.taxIncludedAmount);
              wareHouse.remarks = i.remark;
              obj.tableData.push(wareHouse);
              if (i.adjustFlag === 1) {
                let adjustRecordObj = {}
                adjustRecordObj.detailed = '调整项';
                adjustRecordObj.id = i.id;
                adjustRecordObj.oldAmount = i.adjustRecord.amount;
                adjustRecordObj.oldAmountCopy = numsToRMBSymbolAndMillimeter(i.adjustRecord.amount);
                let taxes = keepTwoDecimal(Number(i.adjustRecord.amount) * (Number(this.baseInfoForm.taxRate)+1))
                adjustRecordObj.taxes = taxes;
                adjustRecordObj.oldTaxIncludedAmount = i.adjustRecord.includedTaxAmount;
                adjustRecordObj.oldTaxIncludedAmountCopy = numsToRMBSymbolAndMillimeter(i.adjustRecord.includedTaxAmount);
                adjustRecordObj.remarks = i.adjustRecord.remarks;
                obj.tableData.push(adjustRecordObj)
              }
            });
            arr.push(obj);
          });
          if (arr.length > 4) {
            let listObj = arr[arr.length - 1]
            arr.splice(3, 0, listObj)
            arr.splice(arr.length - 1, 1)
          }
          this.list = arr;
        } else {
          this.$message.error(res.message);
          if (res.message === '账单不存在') {
            let parentSelectWarehouseAndProject = []
            let projectObj = {}
            projectObj.name = this.baseInfoForm.projectName
            projectObj.id = this.baseInfoForm.projectId
            parentSelectWarehouseAndProject.push(projectObj)
            this.parentSelectWarehouseAndProject = parentSelectWarehouseAndProject
            this.$bus.emit('initParentSelectWarehouseAndProject', this.parentSelectWarehouseAndProject)
          }
        }
      });
    },

    /**
     * @desc 获取调整记录
     */
    initRecordList() {
      let billId = this.id
      let pageNo = this.recordsCurrentPage
      let sortType = this.sortType
      let data = {
        billId,
        pageNo,
        sortType
      }
      Financial.getRecordsList(data).then((res) => {
        if (res.success) {
          let { pageSize, totalNum, items } = res.result
          this.recordsPageSize = pageSize;
          this.recordsTotal = totalNum;
          let arr = []
          items.map(i => {
            let obj = {}
            obj.time = formaTimeToAllSecond(i.createTime)
            obj.operator = i.operator
            obj.accountName = i.detailName
            obj.amount = numsToRMBSymbolAndMillimeter(i.amount)
            obj.remarks = i.remarks
            arr.push(obj)
          })
          this.recordsData = arr
        } else {
          this.$message.error(res.message);
        }
      })
    },

    initDetailsInfo() {
      this.initBillDetails()
      this.initRecordList()
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if (columnIndex === 5) {
        return 'right-align'
      }
    },

    headerExpenseInfoCellClassName({ columnIndex }) {
      if (columnIndex > 0 && columnIndex < 4) {
        return 'right-align'
      }
    },

    headerRecordsCellClassName({ columnIndex }) {
      if (columnIndex === 3) {
        return 'right-align'
      }
    },

    /**
     * @desc 选择仓库
     */
    changeWarehouse() {
      this.initProjectListByWarehouse(this.billRecalculationForm.warehouseId)
    },

    async changeSearchWarehouse() {
      await this.initProjectListByWarehouseCopy(this.search.warehouseId)
      if (!this.projectListByWarehouseAndAuth.length) this.search.projectId = ''
    },

    changeProject() {
      let obj = this.projectListByWarehouseAndAuth.find(item => { return item.id == this.search.projectId })
      this.search.customer = obj.customerId
    },

    clearProjectAndCustomer() {
      this.search.customer = ''
      this.search.projectId = ''
    },

    /**
     * @desc 翻页
     */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initFinancicalReconciliationList();
    },

    searchList() {
      this.currentPage = 1
      this.initFinancicalReconciliationList();
    },

    resetForm(formName) {
      this.search.customer = ''
      this.$refs[formName].resetFields();
      this.search.date = ''
      this.search.month = ''
    },

    pro() {
      this.proFnc()
    },

    next() {
      this.nextFnc()
    },

    /**
     * @desc 调整记录排序
     */
    sortFnc(v) {
      this.sortType = v
      this.initRecordList()
    },

    /**
     * @desc 调整记录分页
     */
    recordsQueryChange(data) {
      this.recordsCurrentPage = data.currentPage;
      this.initRecordList();
    },

    /**
     * @desc 导出月账单
     */
    exportMonthBillForm() {
      let data = {}
      if (this.drawer) {
        data.billIdList = this.oneBillIdList
      } else {
        data.billIdList = this.billIdList
      }
      data.type = this.monthExportRadio
      Financial.getExport(data, this.search.select).then((res) => {
        if (res.data.type !== 'application/x-msdownload') {
          // 报错信息
          let blob = new Blob([res.data], { type: res.headers.contentType });
          const fileReader = new FileReader()
          fileReader.readAsText(blob, 'utf-8')
          // 每次读取操作完成都会触发此事件
          fileReader.onload = () => {
            // 返回的信息
            const result = JSON.parse(fileReader.result)
            if (!result.success) {
              this.$message.error(result.message)
              this.loading = false
            }
          }
        } else {
          downLoadFileByBlob(res)
          this.loading = false
          this.closeExportDialog()
        }
      })
    },

    /**
     * @desc 导出日账单
     */
    exportDateBillForm() {
      let data = {}
      if (this.drawer) {
        data.billIdList = this.oneBillIdList
      } else {
        data.billIdList = this.billIdList
        if (this.billIdList.length === 0) {
          this.$message.error('请选择账单')
          return
        }
      }
      Financial.getExport(data, this.search.select).then((res) => {
        downLoadFileByBlob(res)
      });
    },

    /**
     * @desc 所选中的商品数据
     */
    handleSelectionChange(val) {
      let arr = []
      val.map(i => {
        arr.push(i.id)
      })
      this.billIdList = arr
    },

    toUrl(v) {
      this.$router.push({
        path: v,
      });
    },

    /**
     * @desc 核实账单
     */
    batchVerification() {
      this.$confirm("核实后，该账单将不可再次修改，请确认", "核实", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          id: this.id
        }
        Financial.postVerify(data).then(res => {
          if (res.success) {
            this.initDetailsInfo()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },


    /* 批量核实 */
    batchVerify() {
      if (this.billIdList.length == 0) {
        this.$message.error('请先选择账单');
        return
      }
      let billIds = this.billIdList
      let data = {
        billIds
      }
      Financial.postBatchVerification(data).then(res => {
        if (res.success) {
          this.initFinancicalReconciliationList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * @desc 打开账单重算抽屉
     */
    billRecalculation() {
      this.billRecalculationDrawer = true
    },

    handleCloseBillRecalculationDrawer() {
      this.$refs['billRecalculationForm'].resetFields();
      this.billRecalculationDrawer = false
    },

    /**
     * @desc 保存账单重算
     */
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.billRecalculationForm.warehouseId
          let projectId = this.billRecalculationForm.projectId ? this.billRecalculationForm.projectId : 0
          let type = this.search.select
          let date = this.billRecalculationForm.date
          let repeatCalExpress = this.billRecalculationForm.freightRecalculation == 1 ? true : false
          let telephone = this.billRecalculationForm.telephone
          let data = {
            warehouseId,
            projectId,
            type,
            date,
            repeatCalExpress,
            telephone
          }
          Financial.postBillRecalculation(data).then(res => {
            if (res.success) {
              this.initFinancicalReconciliationList();
              this.handleCloseBillRecalculationDrawer()
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },

    lookDetails(row) {
      this.id = row.id
      this.billDateDetails = row.creatTime
      this.projectId = row.projectId
      this.initDetailsInfo()
      this.drawer = true
    },

    handleCloseDrawer() {
      this.sortType = null
      this.drawer = false
    },

    /**
     * @desc 获取已设置的仓库和项目
     */
    getSelectWarehouseAndProject(v) {
      this.parentSelectWarehouseAndProject = v
      if (v.length > 0) {
        this.projectId = v[0].id
        this.initDetailsInfo()
      }
    },

    /**
     * @desc 文件超出个数限制时
     */
    handleExceed() {
      this.$message({
        message: "文件上传数量最多6张",
        type: "warning",
      });
    },

    /**
     * @desc 上传文件进行文件格式判断
     */
    beforeUpload(file) {
      const isFile =
        file.type === "application/msword" ||
        file.type === "application/vnd.ms-excel" ||
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const isLt5M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
      if (!isFile) {
        this.$message.error("上文件格式错误!");
        return false;
      } else if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
        return false;
      } else {
        this.isUploadText = false
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then(res => {
            if (res.errorCode === 0) {
              this.$nextTick(() => {
                let obj = {};
                obj.desc = res.imgUrl;
                obj.name = file.name;
                this.fileList.push(obj);
                this.images = [];
                this.fileList.map(value => {
                  let imgObj = {}
                  imgObj.name = value.name
                  imgObj.desc = value.url
                  this.images.push(imgObj);
                });
                this.postModifyAttachments()
              })
            } else {
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("图片上传超时，请重新上传");
          });
      }
    },

    /**
     * @desc 修改附件
     */
    postModifyAttachments() {
      let id = this.id
      let attachments = this.images
      let data = {
        id,
        attachments
      }
      Financial.postModifyAttachments(data).then(res => {
        if (!res.success) {
          this.$essage.error(res.message);
        }
      })
    },

    download(item) {
      downLoadFile(item.name, item.desc)
    },

    onRemoveFileList(index) {
      this.images = [];
      this.fileList.splice(index, 1)
      this.images = this.fileList;
      this.postModifyAttachments()
      if (this.fileList.length === 0) {
        this.isUploadText = true
      }
    },

    /**
     * @desc 合计
     */
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          let sumNum = values
            .reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          sums[index] = numsToRMBSymbolAndMillimeter(keepTwoDecimal(sumNum))
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },

    /**
     * @desc 开启调整弹框
     */
    adjustment(billFeeDetailId, subject) {
      this.billFeeDetailId = billFeeDetailId
      this.billForm.amount = 0;
      this.billForm.remarks = "";
      this.billForm.subject = subject;
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
    },

    /**
     * @desc 调整确认
     */
    confirm() {
      let billFeeDetailId = this.billFeeDetailId
      let amount = this.billForm.amount
      let remarks = this.billForm.remarks
      let subject = this.billForm.subject
      let operator = getDBUserRealName()
      let data = {
        billFeeDetailId,
        amount,
        remarks,
        operator,
        subject
      }
      Financial.postAdjust(data).then(res => {
        if (res.success) {
          this.initDetailsInfo()
        } else {
          this.$message.error(res.message);
        }
      });
      this.closeDialog();
    },

    /**
     * @desc 限制单价为2位小数
     */
    inputUnitPrice(val) {
      let price = val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)[0]
        : "";
      this.billForm.amount = price;
    },

    openModRemarks(row) {
      this.modifyRemarksForm.id = row.id
      this.modifyRemarksForm.remarks = row.remarks
      this.modifyRemarksDialog = true
    },

    closeModifyRemarksDialog() {
      this.modifyRemarksForm.id = ''
      this.modifyRemarksForm.remarks = ''
      this.modifyRemarksDialog = false
    },

    /**
     * @desc 修改备注
     */
    modifyRemarks() {
      let id = this.modifyRemarksForm.id
      let remarks = this.modifyRemarksForm.remarks
      let data = {
        id,
        remarks
      }
      Financial.postModifyRemarks(data).then(res => {
        if (!res.success) {
          this.$message.error(res.message);
        } else {
          this.closeModifyRemarksDialog()
        }
      });
    },

    /** 
     * @desc 开启月账单导出
    */
    openExportMonthBill() {
      if (!this.drawer) {
        if (this.billIdList.length === 0) {
          this.$message.error('请选择账单')
          return
        }
      }
      this.exportDialog = true
    },

    /** 
     * @desc 关闭月账单导出
    */
    closeExportDialog() {
      this.monthExportRadio = 1
      this.exportDialog = false
    },

    /** 
     * @desc 确认月账单导出
    */
    confirmExport() {
      this.loading = true
      this.exportMonthBillForm()
    }
  },
};